import "@/assets/scss/index/index.scss";
import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueCookies from "vue-cookies";
 
import { useUserInfoStore } from "@/stores/userInfoStore";
import { axiosInstance, checkLoginStatus } from "@/common/request";
import { api_guest } from "@/common/api";
import { ElAlert, ElMessage } from "element-plus";

axios.defaults.headers["content-type"] = "application/x-www-form-urlencoded";
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
const app = createApp(App);
app.use(VueCookies);
app.use(createPinia());
app.use(router);

const userInfo = useUserInfoStore();
axiosInstance.interceptors.request.use((cfg) => {
  cfg.headers["content-type"] = "application/x-www-form-urlencoded";
  if (userInfo.token == "") {
    return cfg;
  }
  cfg.headers.Authorization = "Bearer " + userInfo.token;

  return cfg;
});

checkLoginStatus(api_guest.token_login, userInfo, (isLogin: boolean,message: string) => {
  if (!isLogin) {
    app.mount("#app");
    if(message!=null){
      ElMessage({
        type: 'error',
        showClose: true,
        message:"无法验证登录状态，"+message,
        duration:5000
      });
     
    }
    return;
  }
  window.location.href = `${import.meta.env.VITE_ADMIN_ROOT}/`;
});
